import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {ProgressBarContainer, ProgressBarFill, ProgressBarWrapper} from './ProgressBar.styled';

const ProgressBar = ({ currentStep, maxStep }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let newProgress = ((currentStep / maxStep) * 100 - 10).toFixed(0);
    if (newProgress < 0) {
      newProgress = 0;
    }
    setProgress(Number(newProgress));
  }, [currentStep]);

  return (
    <ProgressBarContainer>
      <ProgressBarWrapper>
        <ProgressBarFill $progress={progress} />
      </ProgressBarWrapper>
    </ProgressBarContainer>
  );
};

ProgressBar.propTypes = {
  currentStep: PropTypes.number,
  maxStep: PropTypes.number,
};
export default ProgressBar;
